import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'

interface DeactivateDeviceResult {
  success?: boolean
  error?: string
}

async function deactivateDevice(deviceId: string): Promise<void> {
  const { data, error } = await supabase.functions.invoke<DeactivateDeviceResult>('deactivate-device', {
    body: { deviceId },
  })

  if (error || data?.error || data?.success !== true) {
    const failure = error ?? new Error(data?.error ?? 'deactivate_device_failed')
    reportUnexpectedError(failure)
    throw failure
  }
}

export function useDeactivateDevice() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deactivateDevice,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['devices'] }),
  })
}
